import {
  REQUEST_AGENCY_INFO,
  RECEIVE_AGENCY_INFO,
  REQUEST_USER_AGENCIES,
  RECEIVE_USER_AGENCIES,
  CLEAR_AGENCY_INFO,
} from 'common/actions/agency';
import {createFetchListReducer} from 'common/reducers/utils';

const defaultReducer = createFetchListReducer({
  name: 'agency',
  pluralName: 'agencies',
});

export default function agencies(state = {
  isFetching: false,
  isFetchingInfo: false,
  items: {},
  info: null,
}, action) {
  switch (action.type) {
    case REQUEST_AGENCY_INFO:
      return Object.assign({}, state, {
        isFetchingInfo: true,
      });
    case RECEIVE_AGENCY_INFO:
      return Object.assign({}, state, {
        isFetchingInfo: false,
        info: action.info,
      });
    case REQUEST_USER_AGENCIES:
      return Object.assign({}, state, {
        isFetching: true,
      });
    case RECEIVE_USER_AGENCIES:
      return Object.assign({}, state, {
        isFetching: false,
        items: action.items,
      });
    case CLEAR_AGENCY_INFO:
      return Object.assign({}, state, {
        info: null,
      });
    default:
      return defaultReducer(state, action);
  }
}



// WEBPACK FOOTER //
// ./src/common/reducers/agency.js